import client from '@/shared/client/okgportal.client';
import type { BaseOkgportalResponce } from '@/shared/model/api.types';
import type { SalesPeriod, SalesPlanComparison, SalesReport, SalesTransfer, TransferInput } from './types';

async function post<T>(path: string, body: SalesPeriod | TransferInput | { departmentId?: number }, signal?: AbortSignal): Promise<T> {
  // The workspace also has legacy @types/axios. Keep config structurally
  // compatible while passing AbortSignal to the installed Axios 1.x runtime.
  const config = { signal, timeout: 30000 };
  const response = await client.post<BaseOkgportalResponce<T>>(`/v2/salesPlans/${path}`, body, config);
  if (!response.data.success || !response.data.data) {
    throw new Error(response.data.error_message || response.data.message || 'Сервер не вернул результат операции');
  }
  return response.data.data;
}

export const salesHistoryApi = {
  report: (period: SalesPeriod, signal?: AbortSignal) => post<SalesReport>('report', period, signal),
  comparison: (period: SalesPeriod, signal?: AbortSignal) => post<SalesPlanComparison>('comparison', period, signal),
  analytics: (departmentId?: number, signal?: AbortSignal) => post<SalesPlanComparison[]>('snapshotAnalytics', { departmentId }, signal),
  snapshot: (period: SalesPeriod) => post<SalesReport>('snapshots', period),
  transfer: (input: TransferInput) => post<SalesTransfer>('transfers', input),
};

export function historyError(error: unknown): string {
  if (error && typeof error === 'object' && 'isAxiosError' in error && error.isAxiosError) {
    const { response } = error as { response?: { status?: number; data?: { error_message?: unknown; message?: unknown } } };
    if (response?.status === 404) return 'Функция ещё не доступна на сервере. Требуется отдельное обновление backend и миграция базы.';
    const body = response?.data;
    const message = body?.error_message || body?.message;
    if (typeof message === 'string') return message;
    if (!response) return 'Нет подтверждения от сервера. Проверьте соединение и обновите отчёт перед повторной операцией.';
  }
  return error instanceof Error ? error.message : 'Не удалось выполнить запрос';
}
